
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"32","viewBox":"0 0 32 32","width":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.904 0a1.239 1.239 0 00-1.211 1.224V4.87h-9.39A1.264 1.264 0 00.042 6.131a1.255 1.255 0 001.261 1.258h3.646v23.387a1.21 1.21 0 00.791 1.146c.155.058.322.086.487.078h19.7a1.226 1.226 0 001.225-1.282V7.388h3.7v-.055a1.234 1.234 0 001.106-1.232 1.239 1.239 0 00-1.106-1.232h-9.364V1.223a1.24 1.24 0 00-1.237-1.224zm1.25 2.463h5.872v2.406h-5.872zm-5.69 4.925h3.924c.01.006.02.018.03.024a1.241 1.241 0 001.007 0c.01-.006.02-.018.03-.024h12.229v22.148H7.461zm3.695 3.557a1.247 1.247 0 00-1.177.857 1.21 1.21 0 00-.055.51v12.299a1.227 1.227 0 00.754 1.143c.149.062.309.096.471.096h.003a1.24 1.24 0 001.237-1.24V12.311a1.241 1.241 0 00-1.232-1.367zm9.836 0a1.238 1.238 0 00-1.232 1.367v12.299a1.238 1.238 0 002.11.876 1.227 1.227 0 00.355-.875V12.313a1.256 1.256 0 00-.313-.958 1.237 1.237 0 00-.919-.409zm-4.919.143a1.226 1.226 0 00-1.224 1.224v12.299a1.227 1.227 0 00.754 1.143c.149.062.309.096.471.096a1.228 1.228 0 00.87-.364 1.227 1.227 0 00.355-.875V12.312a1.22 1.22 0 00-1.224-1.224z"}})])
          )
        }
      }
    